/**
 * RAO — Retail Account Opening module entry point.
 *
 * Owns the new-account workflow (FSR-shaped order: fill cart → generate tasks
 * → create CIFs → reserve account IDs → CIP/OFAC → produce docs → sign (PAUSE)
 * → create accounts → cards → NetTeller → beneficiaries/relationships).
 *
 * Styles are imported here so every RAO route inherits them without having to
 * touch the global stylesheet.
 */
import './styles/rao.css';
import { RaoRoutes } from './routes';

export default function RAO(): JSX.Element {
  return <RaoRoutes />;
}
